import { FacebookIcon, InstagramIcon, TiktokIcon, XTwitterIcon, YouTubeIcon } from "@Icons";
import { InformationCircleIcon, ShoppingCartIcon, MegaphoneIcon, ShareIcon, NewspaperIcon, MapPinIcon } from "@heroicons/vue/24/outline";
import { TextIcon, ImageIcon, RefreshCcwIcon } from "lucide-vue-next";
import _find from "lodash/find";
import YouTube from "@Icons/YouTube.vue";

export const types = [
    {
        icon: ShareIcon,
        key: "bulk",
        label: "Bulk",
    },
    {
        icon: ShareIcon,
        key: "siloing",
        label: "Architecture de site",
    },
    {
        icon: InformationCircleIcon,
        key: "informative",
        label: "Contenu informationnel",
    },
    {
        icon: ShoppingCartIcon,
        key: "commercial",
        label: "Contenu commercial",
    },
    {
        icon: MegaphoneIcon,
        key: "discover",
        label: "Contenu Discover",
    },
    {
        icon: MapPinIcon,
        key: "local",
        label: "Contenu local",
    },
    {
        icon: NewspaperIcon,
        key: "news",
        label: "Contenu d'actualité",
    },
    {
        icon: NewspaperIcon,
        key: "news-now",
        label: "Contenu d'actualité",
    },
    {
        icon: NewspaperIcon,
        key: "rss",
        label: "RSS",
    },
    {
        icon: NewspaperIcon,
        key: "rss-now",
        label: "RSS",
    },
    {
        icon: NewspaperIcon,
        key: "sitemap",
        label: "Sitemap",
    },
    {
        icon: NewspaperIcon,
        key: "url",
        label: "Url",
    },
    {
        icon: YouTubeIcon,
        key: "youtube",
        label: "Youtube",
    },
    {
        icon: RefreshCcwIcon,
        key: "regenerate",
        label: "Régénérer",
    },
];

export const getType = (type) => {
    return _find(types, ["key", type]);
};

export const templates = [
    {
        id: "structure",
        name: "Texte IA by otomatic.ai",
        description: "Texte généré par IA avec une génération multi-prompts, optimisé par otomatic.ai.",
        featured: true,
    },
    {
        id: "classic",
        name: "Mes prompts personnalisés",
        description: "Texte généré par IA avec une génération sur votre prompt.",
    },
    {
        id: "custom",
        name: "Prompt personalisé",
        description: "Generate content with your custom prompts",
    },
];

export const getTemplate = (template) => {
    return _find(templates, ["id", template]);
};

export const planningPerDays = [
    {
        id: 0,
        name: "Tout publier",
    },
    {
        id: 1,
        name: "1",
    },
    {
        id: 2,
        name: "2",
    },
    {
        id: 3,
        name: "3",
    },
    {
        id: 4,
        name: "4",
    },
    {
        id: 5,
        name: "5",
    },
    {
        id: 8,
        name: "8",
    },
];

export const planningDays = [
    {
        id: "monday",
        name: "Lundi",
    },
    {
        id: "tuesday",
        name: "Mardi",
    },
    {
        id: "wednesday",
        name: "Mercredi",
    },
    {
        id: "thursday",
        name: "Jeudi",
    },
    {
        id: "friday",
        name: "Vendredi",
    },
    {
        id: "saturday",
        name: "Samedi",
    },
    {
        id: "sunday",
        name: "Dimanche",
    },
];

export const planningPeriods = [
    { id: "day", name: "jour" },
    { id: "week", name: "semaine" },
    { id: "month", name: "mois" },
    { id: "year", name: "an" },
];

export const socials = [
    {
        id: "video",
        label: "Youtube",
        icon: YouTubeIcon,
    },
    {
        id: "facebook",
        label: "Facebook",
        icon: FacebookIcon,
    },
    {
        id: "twitter",
        label: "X (Twitter)",
        icon: XTwitterIcon,
    },
    {
        id: "instagram",
        label: "Instagram",
        icon: InstagramIcon,
    },
    {
        id: "tiktok",
        label: "Tiktok",
        icon: TiktokIcon,
    },
];

export const getSocial = (social) => {
    return _find(socials, ["id", social]);
};

export const positions = [
    {
        key: "top",
        name: "Haut",
    },
    {
        key: "middle",
        name: "Milieu",
    },
    {
        key: "bottom",
        name: "Bas",
    },
    {
        key: "random",
        name: "Aléatoire",
    },
];

export const getPosition = (position) => {
    return _find(positions, ["key", position]);
};

export const formatMetrics = (metrics) => {
    let m = [];

    const total = parseInt(metrics?.total) || 0;
    const published = parseInt(metrics?.success) || 0;
    const failed = parseInt(metrics?.failed) || 0;
    const progressRate = total > 0 ? ((published + failed) / total) * 100 : 0;
    const failedRate = total > 0 ? (published / total) * 100 : 0;

    m.push({ key: "total", name: "Nombre de publications", value: total });
    m.push({ key: "published", name: "Publications publiées", value: published });
    m.push({ key: "progress_rate", name: "Taux de progression", value: progressRate.toFixed(0), unit: "%" });
    m.push({ key: "success_rate", name: "Taux de réussite", value: failedRate.toFixed(0), unit: "%" });
    return m;
};

export const options = [
    { key: "brief", name: "Brief" },
    { key: "introduction", name: "Introduction" },
    { key: "summary", name: "Résumé" },
    { key: "synthesis", name: "Synthèse" },
    // { key: "bold_words", name: "Mots en gras" },
    { key: "table", name: "Tableau" },
    { key: "comparative_table", name: "Tableau comparatif" },
    { key: "comparison", name: "Comparaison" },
    { key: "list", name: "Liste" },
    { key: "tutorial", name: "Tutoriel" },
    { key: "analysis", name: "Analyse" },
    { key: "code", name: "Code" },
    { key: "quote", name: "Quote" },
    { key: "example", name: "Example" },
    { key: "case_study", name: "Étude de Cas" },
    { key: "glossary", name: "Glossaire" },
    { key: "methodology", name: "Méthodologie" },
    { key: "tips_and_tricks", name: "Conseils et astuces" },
    { key: "criticism", name: "Critique" },
    { key: "strategy", name: "Stratégie" },
    { key: "specifications", name: "Caractéristiques" },
    { key: "forecast", name: "Prévisions" },
    { key: "recommendation", name: "Recommandation" },
    { key: "biography", name: "Biographie" },
    { key: "definition", name: "Définition" },
    { key: "faq", name: "Questions/Réponses (FAQ)" },
    { key: "testimonial", name: "Testimonial" },
    { key: "conclusion", name: "Conclusion" },
];

export const blocks = [
    // text
    {
        key: "text",
        name: (b) => b.settings.name ?? "Text",
        openModalAtStart: (b) => b.settings.prompt === undefined || b.settings.prompt === null || b.settings.prompt.length === 0,
        icon: TextIcon,
        group: "text",
        is_customizable: true,
        parameters: [
            {
                id: "name",
                default: "",
            },
            {
                id: "use_live_data",
                default: true,
            },
            {
                id: "external_links_enabled",
                default: true,
            },
            {
                id: "external_links_no_follow",
                default: false,
            },
            {
                id: "external_links_blank",
                default: false,
            },
            {
                id: "internal_links_enabled",
                default: true,
            },
            {
                id: "prompt",
                default: "",
            },
        ],
    },

    // image
    { key: "image", name: "Image", icon: ImageIcon, group: "image" },

    // embed
    { key: "youtube", name: "Youtube", icon: YouTubeIcon, group: "embed" },
    // { key: "facebook", name: "Facebook", icon: FacebookIcon, group: "embed" },
    // { key: "twitter", name: "X (Twitter)", icon: XTwitterIcon, group: "embed" },
    // { key: "instagram", name: "Instagram", icon: InstagramIcon, group: "embed" },
    // { key: "tiktok", name: "Tiktok", icon: TiktokIcon, group: "embed" },
];

export const getBlock = (block) => {
    return _find(blocks, ["key", block]);
};

export const titleStyles = [
    { key: "informative", name: "Informatif" },
    { key: "commercial", name: "Commercial" },
    { key: "clickbait", name: "Clickbait" },
    { key: "local", name: "Local" },
    { key: "educational", name: "Éducatif" },
    { key: "emotional", name: "Émotionnel" },
    { key: "narrative", name: "Narratif" },
    { key: "urgent", name: "Urgence" },
    { key: "controversial", name: "Controversé" },
    { key: "inspiring", name: "Inspirant" },
    { key: "technical", name: "Technique" },
    { key: "opinion", name: "Opinion" },
    { key: "listicle", name: "Listicle" },
    { key: "comparative", name: "Comparatif" },
    { key: "exclusive", name: "Exclusif" },
    { key: "practical guide", name: "Guide pratique" },
    { key: "retrospective", name: "Rétrospectif" },
    { key: "forecast", name: "Prévisionnel" },
    { key: "announcement", name: "Annonce" },
    { key: "debate", name: "Débat" },
    { key: "collaborative", name: "Collaboratif" },
    { key: "minimalist", name: "Minimaliste" },
    { key: "event", name: "Événementiel" },
    { key: "commited", name: "Engagé" },
];

export const getTitleStyle = (style) => {
    return _find(titleStyles, ["key", style]);
};
